<section class="mfa-flow">
    <header class="mfa-flow__header">
        <h3>{{ 'app.profileSettings.securityModal.mfa.pageTitle' | translate }}</h3>
        <p>{{ 'app.profileSettings.securityModal.mfa.pageSubtitle' | translate }}</p>
    </header>

    <div class="mfa-flow__content">
        <div class="mfa-flow__main">
            @if (!mfaSetup()) {
            <div class="mfa-status-panel">
                <div class="mfa-status-panel__icon">
                    <app-icon icon="icon-shield-regular.svg" color="currentColor" />
                </div>
                @if (canEnableMfa()) {
                <h4>{{ 'app.profileSettings.securityModal.mfa.disabledTitle' | translate }}</h4>
                <p>{{ 'app.profileSettings.securityModal.mfa.disabledBody' | translate }}</p>
                <button type="button" class="safegpt-button" [disabled]="mfaBusy()" (click)="startSetup.emit()">
                    {{ 'app.profileSettings.securityModal.mfa.enable' | translate }}
                </button>
                }
                @if (canDisableMfa()) {
                <h4>{{ 'app.profileSettings.securityModal.mfa.enabledTitle' | translate }}</h4>
                <p>{{ 'app.profileSettings.securityModal.mfa.enabledBody' | translate }}</p>
                <button type="button" class="safegpt-button inverted" [disabled]="mfaBusy()" (click)="disable.emit()">
                    {{ 'app.profileSettings.securityModal.mfa.disable' | translate }}
                </button>
                }
            </div>
            }

            @if (mfaSetup()) {
            <div class="mfa-setup-panel">
                @if (mfaQrCodeDataUrl()) {
                <img class="mfa-setup-panel__qr" [src]="mfaQrCodeDataUrl()"
                    [alt]="'app.profileSettings.securityModal.mfa.qrAlt' | translate" width="220" height="220" />
                }
                <div class="mfa-setup-panel__key">
                    <strong>{{ 'app.profileSettings.securityModal.mfa.setupKey' | translate }}</strong>
                    <code>{{ mfaSetup()?.sharedKey }}</code>
                </div>
                <div class="field">
                    <label for="mfaCode">{{ 'app.profileSettings.securityModal.mfa.code' | translate }}</label>
                    <input id="mfaCode" name="mfaCode" type="text" inputmode="numeric" maxlength="6"
                        [ngModel]="mfaCode()" (ngModelChange)="mfaCodeChange.emit($event)"
                        [placeholder]="'app.profileSettings.securityModal.mfa.codePlaceholder' | translate" />
                </div>
                <button type="button" class="safegpt-button" [disabled]="mfaBusy()" (click)="activate.emit()">
                    {{ 'app.profileSettings.securityModal.mfa.activate' | translate }}
                </button>
            </div>
            }
        </div>

        <aside class="mfa-help-panel">
            <h4>{{ 'app.profileSettings.securityModal.mfa.howItWorks.title' | translate }}</h4>
            <ol>
                <li>
                    <span>1</span>
                    <div>
                        <strong>{{ 'app.profileSettings.securityModal.mfa.howItWorks.download.title' | translate
                            }}</strong>
                        <p>{{ 'app.profileSettings.securityModal.mfa.howItWorks.download.body' | translate }}</p>
                    </div>
                </li>
                <li>
                    <span>2</span>
                    <div>
                        <strong>{{ 'app.profileSettings.securityModal.mfa.howItWorks.scan.title' | translate }}</strong>
                        <p>{{ 'app.profileSettings.securityModal.mfa.howItWorks.scan.body' | translate }}</p>
                    </div>
                </li>
                <li>
                    <span>3</span>
                    <div>
                        <strong>{{ 'app.profileSettings.securityModal.mfa.howItWorks.code.title' | translate }}</strong>
                        <p>{{ 'app.profileSettings.securityModal.mfa.howItWorks.code.body' | translate }}</p>
                    </div>
                </li>
            </ol>
        </aside>
    </div>

    <footer class="mfa-flow__footer">
        <button type="button" class="safegpt-button inverted" (click)="cancelled.emit()">
            {{ 'common.actions.back' | translate }}
        </button>
    </footer>
</section>
